import {
  Avatar,
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  Descriptions,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Progress,
  Row,
  Space,
  Spin,
  Switch,
  ColorPicker,
  Alert,
  Tabs,
  Typography,
  Tag,
  Tooltip,
  FloatButton,
  Select,
} from "antd";
import { GrUpdate } from "react-icons/gr";
import { SiGetx } from "react-icons/si";
import { VscDiscard } from "react-icons/vsc";
import { QuestionCircleOutlined } from "@ant-design/icons";
import Hls from "hls.js";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { FaCloudDownloadAlt, FaCopy, FaRegPlayCircle } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import { makeApiRequest } from "../../shared/api";
import ProcessingModal from "./ProcessingModal";
import styles from "./style.module.scss";
import {
  SaveOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
  CustomerServiceOutlined,
  LinkOutlined,
  CloseCircleOutlined,
  DragOutlined,
  ClockCircleOutlined
} from "@ant-design/icons";

const { Text } = Typography;

const ContentPage = ({ facebotId, knowledgeBaseId }) => {
  const [isLoading, setLoading] = useState(true);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
  const videoRef = useRef(null);
  const [, setIsMobile] = useState(window.innerWidth < 768);
  const [facebotUpdatedOn, setFacebotUpdatedOn] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [, setFacebotName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [lastModified, setLastModified] = useState(null);
  const preRef = useRef(null);
  const [code, setCode] = useState("");
  const [getCodeLoading, setGetCodeLoading] = useState(false);
  const [getCodeError, setGetCodeError] = useState("");
  const [NotificationEmail, setNotificationEmail] = useState("");
  const [enableSalesforceIntegration, setEnableSalesforceIntegration] = useState(false);
  const [salesforceProject, setSalesforceProject] = useState('');
  const [salesforceUrl, setSalesforceUrl] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [avatarImage, setAvatarImage] = useState(null);
  const [avatarData, setAvatarData] = useState(null);
  const [kbDetails, setKbDetails] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [isAutoOpen, setIsAutoOpen] = useState(false);
  const [widgetThemeColor, setWidgetThemeColor] = useState("#1677ff");
  const [widgetPosition, setWidgetPosition] = useState('');
  const [widgetTitle, setWidgetTitle] = useState("AI assistant 24/7");
  const [introVideoUrl, setIntroVideoUrl] = useState("");
  const [isSettingsModalVisible, setIsSettingsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [settingsLoading, setSettingsLoading] = useState(false);
  const [enableNumberInput, setEnableNumberInput] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState(["name"]);
  const [enableWidgetPrompt, setEnableWidgetPrompt] = useState(false);
  const [widgetPromptText, setWidgetPromptText] = useState("I'm here to assist you!");
  const [widgetTextColor, setWidgetTextColor] = useState('#000000');
  const [contactFieldsConfig, setContactFieldsConfig] = useState({ fields: [] });
  const [salesforceIntegrationEnabled, setSalesforceIntegrationEnabled] = useState(false);

  // Component to render and manage contact field configuration
  const ContactFieldsEditor = ({ form, selectedContacts, enableNumberInput }) => {
    // State to track required status for each field
    const [requiredFields, setRequiredFields] = useState({
      name: true,
      email: true,
      phone_number: false
    });
  
    // Update form value when fields change
    useEffect(() => {
      if (selectedContacts && selectedContacts.length) {
        const formattedFields = selectedContacts.map((attr, index) => {
          return {
            label: attr === "name" 
              ? "Name" 
              : attr === "email" 
                ? "Email" 
                : "Phone Number",
            type: attr === "email" ? "email" : attr === "phone_number" ? "phone" : "string",
            required: requiredFields[attr] || attr === "name", // Name is always required
            position: index + 1
          };
        });
        
        const fieldConfig = { fields: formattedFields };
        setContactFieldsConfig(fieldConfig);
        form.setFieldsValue({
          contact_fields_config: JSON.stringify(fieldConfig)
        });
      }
    }, [selectedContacts, requiredFields, form]);
  
    const toggleRequiredStatus = (fieldName) => {
      // Name can't be toggled - it's always required
      if (fieldName === "name") return;
      
      setRequiredFields(prev => ({
        ...prev,
        [fieldName]: !prev[fieldName]
      }));
    };
  
    return (
      <div style={{ marginTop: 16 }}>
        <div style={{ marginBottom: 8 }}>
          <Text strong>Selected Fields Configuration:</Text>
        </div>
        
        {selectedContacts.map((field, index) => (
          <Card 
            key={field} 
            size="small" 
            style={{ 
              marginBottom: 8, 
              backgroundColor: "#f9f9f9", 
              borderLeft: `3px solid ${field === "name" ? "#1890ff" : field === "email" ? "#52c41a" : "#faad14"}`
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontWeight: 500 }}>
                  {field === "name" ? "Name" : field === "email" ? "Email" : "Phone Number"}
                  <Tag 
                    color={field === "name" ? "blue" : field === "email" ? "green" : "orange"}
                    style={{ marginLeft: 8 }}
                  >
                    {field === "email" ? "email" : field === "phone_number" ? "phone" : "string"}
                  </Tag>
                </div>
                <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.45)", marginTop: 4 }}>
                  Position: {index + 1}
                </div>
              </div>
              
              <Checkbox 
                checked={requiredFields[field] || field === "name"} 
                onChange={() => toggleRequiredStatus(field)}
                disabled={field === "name"} // Name is always required
              >
                Required
              </Checkbox>
            </div>
          </Card>
        ))}
        
        {selectedContacts.length === 0 && (
          <Alert
            type="info"
            message="No fields selected"
            description="Enable contact form and select fields to configure them."
            showIcon
          />
        )}
        
        {/* Hidden field to store the formatted JSON configuration */}
        <Form.Item name="contact_fields_config" hidden>
          <Input.TextArea />
        </Form.Item>
      </div>
    );
  };

  useEffect(() => {
    const fetchData = async() => {
      setLoading(true);

      try {
        if (facebotId) {
          const facebotResponse = await makeApiRequest(
            "GET",
            `facebots/${facebotId}`
          );

          if (facebotResponse && facebotResponse.avatar_id) {
            setAvatarData(facebotResponse);
            await getAvatarById(facebotResponse.avatar_id);
            setIsActive(facebotResponse.active || false);
            setIsAutoOpen(facebotResponse.auto_open || false);
            setWidgetThemeColor(facebotResponse.theme_color || "#1677ff");
            setEnableWidgetPrompt(facebotResponse?.enable_widget_prompt || false);
            setWidgetPromptText(facebotResponse?.tooltip_text || "I'm here to assist you!");
            setWidgetTitle(facebotResponse.facebot_title || "");
            setNotificationEmail(facebotResponse.notification_email_id);
            setFacebotUpdatedOn(facebotResponse?.updated_on || null);
            setIntroVideoUrl(facebotResponse.intro_video || "");
            setEnableNumberInput(facebotResponse?.contact_prompt_point > 0);
            setWidgetTextColor(facebotResponse?.tooltip_text_color || '#000000');
            setWidgetPosition(facebotResponse?.widget_placement || 'right');
            setSalesforceIntegrationEnabled(
              !!facebotResponse.salesforce_project
            );
            setSalesforceProject(facebotResponse.salesforce_project || "");
            setSalesforceUrl(facebotResponse.salesforce_url || "");
            setEnableSalesforceIntegration(
              !!facebotResponse.salesforce_project
            );
            
            // Handle contact fields configuration
            const hasContactFields = facebotResponse?.contact_prompt_point > 0;
            setEnableNumberInput(hasContactFields);
            
            // Parse existing contact fields config if available
            let existingConfig = { fields: [] };
            if (facebotResponse?.contact_fields_config) {
              try {
                existingConfig = JSON.parse(facebotResponse.contact_fields_config);
              } catch (e) {
                console.error("Error parsing contact fields config:", e);
              }
            }
            setContactFieldsConfig(existingConfig);
            
            // Extract selected contacts from the fields
            const contactAttrs = facebotResponse.contact_fields?.map(
              (field) => {
                if (field.label === "Name") return "name";
                if (field.label === "Email") return "email";
                if (field.label === "Phone Number") return "phone_number";
                return field.label.toLowerCase();
              }
            ) || ["name", "email"];
            setSelectedContacts(contactAttrs);
            
            // Set form values
            form.setFieldsValue({
              active: facebotResponse?.active || false,
              auto_open: facebotResponse?.auto_open || false,
              theme_color: facebotResponse?.theme_color || "#1677ff",
              facebot_title: facebotResponse?.facebot_title || "",
              intro_script: facebotResponse?.intro_script || "",
              enable_widget_prompt:
                facebotResponse?.enable_widget_prompt || false,
              tooltip_text:
                facebotResponse?.tooltip_text || "I'm here to assist you!",
              enable_contact_fields: hasContactFields,
              contact_prompt_point:
                facebotResponse?.contact_prompt_point || null,
              contact_attributes: contactAttrs,
              notification_emailid: facebotResponse.notification_email_id,
              contact_fields_config:
                facebotResponse?.contact_fields_config ||
                JSON.stringify({ fields: [] }),
              tooltip_text_color:
                facebotResponse?.tooltip_text_color || "#000000",
              enable_salesforce_crm: !!facebotResponse.salesforce_project,
              salesforce_project: facebotResponse.salesforce_project || "",
              salesforce_url: facebotResponse.salesforce_url || "",
              contact_attributes: facebotResponse.contact_fields?.map(
                (field) => {
                  if (field.label === "Name") return "name";
                  if (field.label === "Email") return "email";
                  if (field.label === "Phone Number") return "phone_number";
                  return field.label.toLowerCase();
                }
              ) || ["name"],
            });
            
          } else {
            resetFormData();
          }
        } else {
          resetFormData();
        }

        if (knowledgeBaseId) {
          await getKbDetails(knowledgeBaseId);
        } else {
          setKbDetails(null);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        message.error("Failed to load data.");
        resetFormData();
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [facebotId, knowledgeBaseId, form]);

  const resetFormData = () => {
    setAvatarData(null);
    setSelectedAvatar(null);
    setAvatarImage(null);
    setIsActive(false);
    setIsAutoOpen(false);
    setWidgetThemeColor("#1677ff");
    setWidgetTitle("");
    setKbDetails(null);
    setContactFieldsConfig({ fields: [] });
    setSelectedContacts(["name", "email"]);
  };

  // Add useEffect to handle automatic name selection
  useEffect(() => {
    if (enableNumberInput) {
      const currentAttrs = form.getFieldValue("contact_attributes") || [];
      if (!currentAttrs.includes("name")) {
        const newAttrs = ["name", ...currentAttrs];
        form.setFieldsValue({ contact_attributes: newAttrs });
        setSelectedContacts(newAttrs);
      }
    }
  }, [enableNumberInput, form]);

  const getKbDetails = async(knowledgeBaseId) => {
    try {
      const response = await makeApiRequest("GET", `kb/${knowledgeBaseId}`);
      setKbDetails(response);
      setLastModified(response?.created_on || null);
      console.log("KB Details:", response);
      console.log("lastModified:", response?.created_on);   
    } catch (error) {
      console.error("Error fetching KB details:", error);
      setKbDetails(null);
      setLastModified(null);
      message.error("Failed to load knowledge base details.");
    }
  };

  const getAvatarById = async(avatar_id) => {
    if (!avatar_id) {
      console.warn("Invalid avatar_id:", avatar_id);
      setSelectedAvatar(null);
      setAvatarImage(null);
      return;
    }

    try {
      const response = await makeApiRequest("GET", `avatars/${avatar_id}`);

      if (response) {
        setSelectedAvatar(response);
        setFacebotName(response.avatar_name || "");
        setAvatarImage(response.avatar_image);
      } else {
        throw new Error(`Avatar with ID ${avatar_id} not found`);
      }
    } catch (error) {
      console.error("Error fetching avatar:", error);
      message.error("Failed to load avatar.");
      setSelectedAvatar(null);
      setAvatarImage(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderPreview = () => {
    if (!selectedAvatar?.sample_video) {
      return <Text>No video available for this avatar.</Text>;
    }

    const videoType = introVideoUrl.endsWith(".m3u8")
      ? "application/vnd.apple.mpegurl"
      : "video/mp4";

    return (
      <video
        ref={videoRef}
        controls
        width="100%"
        style={{ backgroundColor: "black" }}
      >
        <source src={introVideoUrl} type={videoType} />
        Your browser does not support the video tag.
      </video>
    );
  };

  useEffect(() => {
    let hls = null;
    if (
      isPreviewModalVisible &&
      videoRef.current &&
      introVideoUrl?.endsWith(".m3u8")
    ) {
      const video = videoRef.current;
      if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(introVideoUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => video.play());
        hls.on(Hls.Events.ERROR, (_, data) => {
          if (data.fatal) {
            switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              hls.recoverMediaError();
              break;
            default:
              hls.destroy();
              break;
            }
          }
        });
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = introVideoUrl;
        video.addEventListener("loadedmetadata", () => video.play());
      }
    }

    return () => {
      if (hls) hls.destroy();
    };
  }, [isPreviewModalVisible, selectedAvatar, introVideoUrl]);

  const handleDownload = () => {
    if (preRef.current) {
      const blob = new Blob([preRef.current.innerText], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "code.html";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };

  const getCode = async() => {
    if (!facebotId) {
      console.warn("No facebotId to get code from.");
      setCode("");
      setGetCodeError("No Facebot Selected");
      return;
    }
    try {
      setGetCodeLoading(true);
      const response = await makeApiRequest("GET", `facebots/${facebotId}`);
      if (response) {
        setCode(response.facebot_script || "");
        setGetCodeError("");
      } else {
        setCode("");
        setGetCodeError("No code returned");
      }
    } catch (error) {
      setCode("");
      setGetCodeError(error?.response?.message || "Failed to generate code");
    } finally {
      setGetCodeLoading(false);
    }
  };

  const handleCopyCode = () => {
    if (preRef.current) {
      navigator.clipboard
        .writeText(preRef.current.innerText)
        .then(() => message.success("Code copied to clipboard!"))
        .catch((err) => message.error("Failed to copy code: " + err));
    }
  };

  const handleGetCode = useCallback(() => {
    setIsModalOpen(true);
    getCode();
  }, []);

  const handleDeleteFacebot = async() => {
    try {
      setLoading(true);
      await makeApiRequest("DELETE", `facebots/${facebotId}`);
    } catch (error) {
      console.error("Error deleting facebot:", error);
      message.error("Failed to delete facebot");
    } finally {
      setLoading(false);
    }
  };

  const handleSettingsChange = async () => {
    try {
      setSettingsLoading(true);
      const formValues = await form.validateFields();

      const payload = {
        facebot_id: facebotId,
        widget_title: widgetTitle,
        widget_placement: widgetPosition,
        theme_color: widgetThemeColor,
        is_active: isActive,
        auto_open: isAutoOpen,
        enable_contact_fields: enableNumberInput,
        // Update contact fields configuration
        ...(enableNumberInput
          ? {
              contact_fields: selectedContacts.map((attr, index) => ({
                label:
                  attr === "name"
                    ? "Name"
                    : attr === "email"
                    ? "Email"
                    : "Phone Number",
                type:
                  attr === "email"
                    ? "email"
                    : attr === "phone_number"
                    ? "phone"
                    : "string",
                required: attr === "name" || attr === "email",
                position: index + 1,
              })),
              notification_email_id: NotificationEmail?.trim() || "",
              contact_prompt_point: form.getFieldValue("contact_prompt_point"),
              // Add Salesforce fields if both contact and Salesforce are enabled
              ...(enableSalesforceIntegration
                ? {
                    salesforce_project: formValues.salesforce_project || "",
                    salesforce_url: formValues.salesforce_url || "",
                  }
                : {
                    salesforce_project: "",
                    salesforce_url: "",
                  }),
            }
          : {
              contact_fields: [],
              notification_email_id: "",
              contact_prompt_point: null,
              salesforce_project: "",
              salesforce_url: "",
            }),
        intro_script: form.getFieldValue("intro_script") || "",
        enable_widget_prompt: enableWidgetPrompt,
        widget_prompt_text: widgetPromptText,
        tooltip_text_color: widgetTextColor,
      };
  
      const response = await makeApiRequest("PUT", `facebots/${facebotId}`, payload);
      
      if (response) {
        setIsAutoOpen(formValues.auto_open || false);
        setWidgetTitle(formValues.facebot_title || "");
        setWidgetPosition(formValues.widget_placement || "");
        setWidgetThemeColor(formValues.theme_color || "#1677ff");
        setEnableWidgetPrompt(formValues.enable_widget_prompt || false);
        setWidgetPromptText(formValues.tooltip_text || "");
        setWidgetTextColor(formValues.tooltip_text_color || "#000000");
        if (enableNumberInput) {
          setSelectedContacts(formValues.contact_attributes || ["name"]);
          setNotificationEmail(formValues.notification_emailid || "");

          // Update Salesforce states
          setEnableSalesforceIntegration(!!formValues.salesforce_project);
          setSalesforceProject(formValues.salesforce_project || "");
          setSalesforceUrl(formValues.salesforce_url || "");
          setSalesforceIntegrationEnabled(!!formValues.salesforce_project);
        } else {
          // Reset Salesforce states when contact form is disabled
          setEnableSalesforceIntegration(false);
          setSalesforceProject("");
          setSalesforceUrl("");
          setSalesforceIntegrationEnabled(false);
        }

        // Update form values to ensure consistency
        form.setFieldsValue({
          ...formValues,
          enable_salesforce_crm: !!formValues.salesforce_project,
          salesforce_project: formValues.salesforce_project || "",
          salesforce_url: formValues.salesforce_url || "",
          contact_attributes: formValues.contact_attributes || ["name"],
        });
        message.success("Facebot settings updated successfully");
        setIsSettingsModalVisible(false);
      } else {
        throw new Error("No response from server");
      }
    } catch (error) {
      console.error('Settings update error:', error);
      message.error(error.message || 'Failed to update facebot settings');
    } finally {
      setSettingsLoading(false);
    }
  };

  const showSettingsModal = () => {
    setIsSettingsModalVisible(true);
  };

  const handleCancelSettingsModal = () => {
    setIsSettingsModalVisible(false);
  };

  return (
    <div className={styles.container}>
      <Card
        loading={isLoading}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "18px", fontWeight: 600 }}>
              FaceBot Details
            </span>
            <Tooltip
              title={
                <div style={{ maxWidth: "300px", padding: "8px 0" }}>
                  <div
                    style={{
                      marginBottom: "8px",
                      fontWeight: "500",
                      color: "#ff692e",
                    }}
                  >
                    FaceBot Configuration
                  </div>
                  <div style={{ marginBottom: "8px", color: "#21130d" }}>
                    Manage and customize your FaceBot's appearance and behavior
                  </div>
                  <ul
                    style={{
                      margin: "0",
                      paddingLeft: "16px",
                      color: "#21130d",
                    }}
                  >
                    <li>
                      Update widget settings and appearance by{" "}
                      <Text mark style={{ padding: "2px 4px" }}>
                        Update settings{" "}
                      </Text>
                      button
                    </li>
                    <li>Get code for Widget Intergration for website</li>
                    <li>Monitor facebot's generation progress</li>
                  </ul>
                </div>
              }
              placement="right"
              color="#ffffff"
            >
              <QuestionCircleOutlined
                style={{
                  fontSize: "16px",
                  color: "#1677ff",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          </div>
        }
        style={{ border: "none" }}
      >
        {/* Main content here - unchanged from original */}
        <Row gutter={[24, 24]} align="top">
          <Col xs={24} md={12}>
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
                borderRadius: "12px",
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {isLoading ? (
                <Skeleton height={300} width={300} borderRadius="12px" />
              ) : selectedAvatar && avatarImage ? (
                <>
                  <Avatar
                    size={300}
                    src={avatarImage}
                    shape="square"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      cursor:
                        avatarData?.facebot_status === "HLS_VIDEO_UPLOADED"
                          ? "pointer"
                          : "default",
                      filter:
                        isHovered &&
                        avatarData?.facebot_status === "HLS_VIDEO_UPLOADED"
                          ? "brightness(80%)"
                          : "none",
                      transition: "filter 0.3s ease-in-out",
                    }}
                    onClick={() =>
                      avatarData?.facebot_status === "HLS_VIDEO_UPLOADED" &&
                      setIsPreviewModalVisible(true)
                    }
                  />
                  {isHovered &&
                    avatarData?.facebot_status === "HLS_VIDEO_UPLOADED" && (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          backgroundColor: "rgba(0, 0, 0, 0.7)",
                          color: "white",
                          fontSize: "3rem",
                          width: "40px",
                          height: "40px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "50%",
                          cursor: "pointer",
                          transition: "background-color 0.3s ease",
                        }}
                        onClick={() => setIsPreviewModalVisible(true)}
                      >
                        <FaRegPlayCircle />
                      </div>
                    )}
                </>
              ) : (
                <Text>No Avatar Found</Text>
              )}
            </div>
          </Col>
          <Col xs={24} md={12}>
            {isLoading ? (
              <>
                <Skeleton height={40} width={250} />
                <Skeleton height={25} width="80%" count={3} />
              </>
            ) : kbDetails ? (
              <Descriptions
                bordered
                column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                size="small"
              >
                <Descriptions.Item label="Knowledge Base Name">
                  <Text strong>{kbDetails?.kb_name || "No Name"}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Description">
                  <Text>{kbDetails?.kb_description || "No Description"}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  <Text type={isActive ? "success" : "danger"}>
                    <Badge
                      status="processing"
                      color={isActive ? "#52c41a" : "#ff4d4f"}
                    />{" "}
                    {isActive ? "Active" : "Inactive"}
                  </Text>
                </Descriptions.Item>
                <Descriptions.Item label="Auto Trigger">
                  <Text>{isAutoOpen ? "Enabled" : "Disabled"}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Theme Color">
                  <div
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor: widgetThemeColor,
                      display: "inline-block",
                      verticalAlign: "middle",
                      marginRight: "8px",
                    }}
                  />
                  <Text>{widgetThemeColor}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Widget Title">
                  <Text>{widgetTitle || "AI assistant 24/7"}</Text>
                </Descriptions.Item>
              </Descriptions>
            ) : (
              <Text>No Knowledge Base Information Found</Text>
            )}
          </Col>
        </Row>

        <div
          style={{
            marginTop: 20,
            marginBottom: 20,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Space size="large">
            <Button
              danger
              size="large"
              style={{
                borderRadius: "8px",
                width: "auto",
                visibility: "hidden",
              }}
              onClick={handleDeleteFacebot}
              disabled={isLoading}
            >
              Delete
            </Button>

            <Button
              type="primary"
              size="large"
              style={{ borderRadius: "8px", width: "auto" }}
              onClick={handleGetCode}
              icon={<SiGetx />}
              disabled={
                avatarData?.progress !== 100 || getCodeLoading || isLoading
              }
            >
              Get Code
            </Button>

            <Button
              type="default"
              size="large"
              style={{ borderRadius: "8px", width: "auto" }}
              onClick={showSettingsModal}
              icon={<GrUpdate />}
            >
              Update Settings
            </Button>
          </Space>
        </div>

        <Progress
          type="line"
          percent={avatarData?.progress ?? 0}
          strokeColor={avatarData?.progress === 100 ? "#52c41a" : "#1890ff"}
          format={(percent) => `Generation Progress: ${percent}%`}
          strokeWidth={8}
        />
        <div
          style={{
            marginTop: 16,
            display: "flex",
            alignItems: "center",
            gap: 8,
            color: "rgba(0, 0, 0, 0.45)",
            fontSize: 14,
          }}
        >
          <ClockCircleOutlined style={{ fontSize: 16 }} />
          <span>
            Facebot created on:{" "}
            {lastModified
              ? new Date(lastModified).toLocaleString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "Not Available"}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            color: "rgba(0, 0, 0, 0.45)",
            fontSize: 14,
          }}
        >
          <ClockCircleOutlined style={{ fontSize: 16 }} />
          <span>
            FaceBot last updated:{" "}
            {facebotUpdatedOn
              ? new Date(facebotUpdatedOn).toLocaleString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "Not Available"}
          </span>
        </div>
      </Card>

      <Modal
        title={
          <span style={{ fontSize: 18, fontWeight: 600 }}>
            Facebot Configuration
          </span>
        }
        open={isSettingsModalVisible}
        onCancel={handleCancelSettingsModal}
        confirmLoading={settingsLoading}
        width={680}
        style={{ top: 40 }}
        Style={{ padding: "24px 24px 8px" }}
        footer={null} // We'll build custom footer
      >
        <Form form={form} layout="vertical">
          {/* Header Tabs */}
          <div style={{ marginBottom: 24 }}>
            <Tabs defaultActiveKey="1" animated>
              <Tabs.TabPane tab="⚙️ Core Settings" key="1">
                {/* Toggle Section */}
                <Card
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span style={{ color: "#1890ff" }}>Behavior</span>
                      <Tooltip
                        title={
                          <div style={{ maxWidth: "300px", padding: "8px 0" }}>
                            <div
                              style={{
                                marginBottom: "8px",
                                fontWeight: "500",
                                color: "#1890ff",
                              }}
                            >
                              Widget Behavior Settings
                            </div>
                            <div
                              style={{ marginBottom: "8px", color: "#21130d" }}
                            >
                              Configure how your widget behaves on your website
                            </div>
                            <ul
                              style={{
                                margin: "0",
                                paddingLeft: "16px",
                                color: "#21130d",
                              }}
                            >
                              <li>Toggle widget activation status</li>
                              <li>
                                Set auto-trigger preferences for widget
                                auto-open
                              </li>
                              <li>Control widget visibility and interaction</li>
                            </ul>
                          </div>
                        }
                        placement="right"
                        color="#ffffff"
                      >
                        <QuestionCircleOutlined
                          style={{
                            fontSize: "14px",
                            color: "#1890ff",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </div>
                  }
                  size="small"
                  style={{
                    marginBottom: 24,
                    borderLeft: "3px solid #1890ff",
                    borderBottom: 0,
                    paddingBottom: 0,
                  }}
                >
                  <Row gutter={24}>
                    <Col span={8}>
                      <Form.Item
                        name="active"
                        label={
                          <span style={{ fontWeight: 500 }}>
                            Activation Status
                          </span>
                        }
                        valuePropName="checked"
                      >
                        <Switch
                          checkedChildren="ACTIVE"
                          unCheckedChildren="INACTIVE"
                          style={{ minWidth: 90 }}
                          checked={isActive}
                          onChange={(checked) => {
                            setIsActive(checked);
                            form.setFieldsValue({ active: checked });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="audio_input"
                        label={
                          <span style={{ fontWeight: 500 }}>
                            Enable Microphone
                          </span>
                        }
                        valuePropName="checked"
                        style={{ marginBottom: 16 }}
                      >
                        <Switch
                          defaultChecked={true}
                          disabled={true}
                          checkedChildren="Enabled"
                          unCheckedChildren="Disabled"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="auto_open"
                        label={
                          <span style={{ fontWeight: 500 }}>Trigger Mode</span>
                        }
                        valuePropName="checked"
                      >
                        <Switch
                          checkedChildren="AUTO"
                          unCheckedChildren="MANUAL"
                          style={{ minWidth: 90 }}
                          onChange={(checked) => {
                            setIsAutoOpen(checked);
                            form.setFieldsValue({ auto_open: checked });
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                {/* Contact Form Section */}
                <Card
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span style={{ color: "#6739b6" }}>Contact Form</span>
                      <Tooltip
                        title={
                          <div style={{ maxWidth: "300px", padding: "8px 0" }}>
                            <div
                              style={{
                                marginBottom: "8px",
                                fontWeight: "500",
                                color: "#6739b6",
                              }}
                            >
                              Contact Form Settings
                            </div>
                            <div
                              style={{ marginBottom: "8px", color: "#21130d" }}
                            >
                              Configure contact form fields to collect visitor
                              information
                            </div>
                          </div>
                        }
                        placement="right"
                        color="#ffffff"
                      >
                        <QuestionCircleOutlined
                          style={{
                            fontSize: "14px",
                            color: "#6739b6",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </div>
                  }
                  size="small"
                  style={{
                    marginBottom: 24,
                    borderLeft: "3px solid #6739b6",
                    borderBottom: 0,
                    paddingBottom: 0,
                  }}
                >
                  <Form.Item
                    name="enable_contact_fields"
                    valuePropName="checked"
                    style={{ marginBottom: 16 }}
                  >
                    {/* <Checkbox.Group> */}
                    <Checkbox
                      onChange={(e) => {
                        setEnableNumberInput(e.target.checked);
                        if (e.target.checked) {
                          // When enabling, automatically set name and email
                          const defaultValues = ["name", "email"];
                          setSelectedContacts(defaultValues);
                          form.setFieldsValue({
                            contact_attributes: defaultValues,
                          });
                        } else {
                          // When disabling, clear all selections
                          setSelectedContacts([]);
                          form.setFieldsValue({ contact_attributes: [] });
                        }
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        Enable Contact Fields
                      </span>
                    </Checkbox>
                    {/* </Checkbox.Group> */}
                  </Form.Item>
                  {enableNumberInput && (
                    <>
                      <Form.Item
                        name="contact_prompt_point"
                        style={{ marginBottom: 0 }}
                        rules={[
                          {
                            required: enableNumberInput,
                            message:
                              "Please enter a numerical value (greater than 0)",
                            type: "number",
                            min: 1,
                            max: 20,
                          },
                        ]}
                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          min={1}
                          max={20}
                          accept="number"
                          placeholder="Update Contact form Position number"
                          disabled={!enableNumberInput}
                          precision={0}
                          size="large"
                        />
                      </Form.Item>
                      <Form.Item
                        name="contact_attributes"
                        label={
                          <span style={{ fontWeight: 500 }}>
                            Select Contact Attributes
                          </span>
                        }
                        style={{ marginBottom: 16, marginTop: 16 }}
                        rules={[
                          {
                            validator: (_, value) => {
                              if (enableNumberInput) {
                                if (
                                  !value ||
                                  !value.includes("name") ||
                                  !value.includes("email") ||
                                  !form.getFieldValue("notification_emailid")
                                ) {
                                  return Promise.reject(
                                    "Name and Email fields are mandatory when contact is enabled"
                                  );
                                }
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Select
                          mode="multiple"
                          disabled={!enableNumberInput}
                          placeholder="Select contact form fields"
                          style={{ width: "100%" }}
                          size="large"
                          value={selectedContacts}
                          onChange={(values) => {
                            if (enableNumberInput) {
                              const mandatoryFields = ["name", "email"];
                              const optionalFields = values.filter(
                                (v) => v === "phone_number"
                              );
                              const newValues = [
                                ...mandatoryFields,
                                ...optionalFields,
                              ];
                              setSelectedContacts(newValues);
                              form.setFieldsValue({
                                contact_attributes: newValues,
                              });
                            }
                          }}
                          defaultValue={["name", "email"]}
                          options={[
                            {
                              value: "name",
                              label: (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span>
                                    Name{" "}
                                    <Text
                                      type="danger"
                                      style={{ marginLeft: 4 }}
                                    >
                                      *
                                    </Text>
                                  </span>
                                </div>
                              ),
                              disabled: true, // Name is always disabled since it's mandatory
                            },
                            {
                              value: "email",
                              label: (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span>
                                    Email{" "}
                                    <Text
                                      type="danger"
                                      style={{ marginLeft: 4 }}
                                    >
                                      *
                                    </Text>
                                  </span>
                                </div>
                              ),
                              disabled: false, // Email is now also disabled since it's mandatory
                            },
                            { value: "phone_number", label: "Phone Number" },
                          ]}
                        />
                      </Form.Item>

                      <Form.Item
                        name="notification_emailid"
                        label={
                          <span style={{ fontWeight: 500 }}>
                            Email to Notify
                          </span>
                        }
                        initialValue={NotificationEmail}
                        tooltip="Email address where contact form submissions will be sent"
                        style={{ marginBottom: 16 }}
                        rules={[
                          {
                            type: "email",
                            message: "Please enter a valid email address",
                          },
                          {
                            validator: (_, value) => {
                              if (enableNumberInput && !value) {
                                return Promise.reject(
                                  "Notification email is required when contact is enabled"
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter email address"
                          onChange={(e) => setNotificationEmail(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        name="enable_salesforce_crm"
                        label={
                          <span style={{ fontWeight: 500 }}>
                            Enable Salesforce CRM Integration
                          </span>
                        }
                        tooltip="Enable to sync contact form submissions with Salesforce"
                        valuePropName="checked"
                        style={{ marginBottom: 16 }}
                      >
                        <Switch
                          onChange={(checked) =>
                            setEnableSalesforceIntegration(checked)
                          }
                          defaultChecked={false}
                        />
                      </Form.Item>
                      {enableSalesforceIntegration && (
                        <>
                          <Form.Item
                            name="salesforce_project"
                            label={
                              <span style={{ fontWeight: 500 }}>
                                Salesforce Project
                              </span>
                            }
                            tooltip="Enter your Salesforce project name"
                            style={{ marginBottom: 16 }}
                            rules={[
                              {
                                required: true,
                                message:
                                  "Please enter your Salesforce Project name",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Enter project name"
                              onChange={(e) => {
                                form.setFieldsValue({
                                  salesforce_project: e.target.value,
                                });
                                setSalesforceProject(e.target.value);
                              }}
                            />
                          </Form.Item>
                          <Form.Item
                            name="salesforce_url"
                            label={
                              <span style={{ fontWeight: 500 }}>
                                Salesforce URL
                              </span>
                            }
                            tooltip="Enter your Salesforce endpoint URL"
                            style={{ marginBottom: 16 }}
                            rules={[
                              {
                                required: true,
                                message: "Please enter your Salesforce URL",
                              },
                            ]}
                          >
                            <Input
                              placeholder="https://your-instance.salesforce.com/Id/webToLead"
                              onChange={(e) => {
                                form.setFieldsValue({
                                  salesforce_url: e.target.value,
                                });
                                setSalesforceUrl(e.target.value);
                              }}
                            />
                          </Form.Item>
                        </>
                      )}
                    </>
                  )}
                </Card>
                <Card
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span style={{ color: "#13c2c2" }}>Widget Prompt</span>
                      <Tooltip
                        title={
                          <div style={{ maxWidth: "300px", padding: "8px 0" }}>
                            <div
                              style={{
                                marginBottom: "8px",
                                fontWeight: "500",
                                color: "#13c2c2",
                              }}
                            >
                              Widget Prompt Settings
                            </div>
                            <div
                              style={{ marginBottom: "8px", color: "#21130d" }}
                            >
                              Configure the prompt text shown in the widget
                            </div>
                          </div>
                        }
                        placement="right"
                        color="#ffffff"
                      >
                        <QuestionCircleOutlined
                          style={{
                            fontSize: "14px",
                            color: "#13c2c2",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </div>
                  }
                  size="small"
                  style={{
                    marginBottom: 24,
                    borderLeft: "3px solid #13c2c2",
                    borderBottom: 0,
                    paddingBottom: 0,
                  }}
                >
                  <Form.Item
                    name="enable_widget_prompt"
                    valuePropName="checked"
                    style={{ marginBottom: 16 }}
                  >
                    <Checkbox
                      checked={enableWidgetPrompt}
                      onChange={(e) => setEnableWidgetPrompt(e.target.checked)}
                    >
                      <span style={{ fontWeight: 500 }}>
                        Enable Widget Prompt Text
                      </span>
                    </Checkbox>
                  </Form.Item>

                  {enableWidgetPrompt && (
                    <>
                      <Form.Item
                        name="tooltip_text"
                        label="Widget Prompt Text"
                        extra="This appears as a prompt message in the widget"
                      >
                        <Input
                          placeholder="Enter prompt text"
                          defaultValue="I'm here to assist you!"
                          allowClear
                          maxLength={30}
                          showCount
                          size="large"
                          onChange={(e) => setWidgetPromptText(e.target.value)}
                        />
                      </Form.Item>

                      <Form.Item
                        name="tooltip_text_color"
                        label="Widget Text Color"
                        tooltip="Choose the color for your widget prompt text"
                      >
                        <ColorPicker
                          showText
                          size="large"
                          value={widgetTextColor}
                          defaultValue="#000000"
                          onChange={(color) =>
                            setWidgetTextColor(color.toHexString())
                          }
                          presets={[
                            {
                              label: "Recommended Colors",
                              colors: [
                                "#000000",
                                "#FFFFFF",
                                "#1890ff",
                                "#6739b6",
                                "#ff6b81",
                                "#52c41a",
                                "#faad14",
                                "#13c2c2",
                                "#eb2f96",
                              ],
                            },
                          ]}
                        />
                      </Form.Item>
                    </>
                  )}
                </Card>
              </Tabs.TabPane>

              <Tabs.TabPane tab="🎨 Appearance" key="2">
                {/* Appearance Section */}
                <Card
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span style={{ color: "#ff6b81" }}>Visual Style</span>
                      <Tooltip
                        title={
                          <div style={{ maxWidth: "300px", padding: "8px 0" }}>
                            <div
                              style={{
                                marginBottom: "8px",
                                fontWeight: "500",
                                color: "#ff6b81",
                              }}
                            >
                              Visual Customization Settings
                            </div>
                            <div
                              style={{ marginBottom: "8px", color: "#21130d" }}
                            >
                              Personalize your widget's visual appearance
                            </div>
                            <ul
                              style={{
                                margin: "0",
                                paddingLeft: "16px",
                                color: "#21130d",
                              }}
                            >
                              <li>Choose custom theme colors</li>
                              <li>Set widget title and branding</li>
                            </ul>
                          </div>
                        }
                        placement="right"
                        color="#ffffff"
                      >
                        <QuestionCircleOutlined
                          style={{
                            fontSize: "14px",
                            color: "#ff6b81",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </div>
                  }
                  size="small"
                  style={{
                    marginBottom: 24,
                    borderLeft: "3px solid #ff6b81",
                    borderBottom: 0,
                    paddingBottom: 0,
                  }}
                >
                  <Form.Item
                    name="theme_color"
                    label={
                      <span style={{ fontWeight: 500 }}>Primary Color</span>
                    }
                  >
                    <ColorPicker
                      showText
                      size="large"
                      presets={[
                        {
                          label: "Recommended Colors",
                          colors: [
                            "#1890ff",
                            "#6739b6",
                            "#ff6b81",
                            "#52c41a",
                            "#faad14",
                            "#13c2c2",
                            "#eb2f96",
                            "#722ed1",
                            "#fadb14",
                          ],
                        },
                      ]}
                      panelRender={(panel) => (
                        <div style={{ padding: 10 }}>{panel}</div>
                      )}
                    />
                  </Form.Item>

                  <Form.Item
                    name="facebot_title"
                    label={
                      <span style={{ fontWeight: 500 }}>Widget Title</span>
                    }
                    extra="This appears at the top of the widget"
                  >
                    <Input
                      placeholder="e.g. Support Assistant"
                      allowClear
                      maxLength={30}
                      showCount
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item
                    name="widgetPosition"
                    label={
                      <span style={{ fontWeight: 500 }}>Widget Position</span>
                    }
                    initialValue={widgetPosition}
                    tooltip="Select the position where the widget should appear on the website"
                  >
                    <Select
                      value={widgetPosition}
                      onChange={(value) => setWidgetPosition(value)}
                      options={[
                        { value: "right", label: "Right" },
                        { value: "left", label: "Left" },
                      ]}
                    />
                  </Form.Item>
                </Card>
              </Tabs.TabPane>

              <Tabs.TabPane tab="💬 Interactions" key="3">
                {/* Script Section */}
                <Card
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span style={{ color: "#13c2c2" }}>
                        Conversation Flow
                      </span>
                      <Tooltip
                        title={
                          <div style={{ maxWidth: "300px", padding: "8px 0" }}>
                            <div
                              style={{
                                marginBottom: "8px",
                                fontWeight: "500",
                                color: "#13c2c2",
                              }}
                            >
                              Chat Interaction Settings
                            </div>
                            <div
                              style={{ marginBottom: "8px", color: "#21130d" }}
                            >
                              Configure how your FaceBot interacts with visitors
                            </div>
                            <ul
                              style={{
                                margin: "0",
                                paddingLeft: "16px",
                                color: "#21130d",
                              }}
                            >
                              <li>Customize initial conversation flow</li>
                            </ul>
                          </div>
                        }
                        placement="right"
                        color="#ffffff"
                      >
                        <QuestionCircleOutlined
                          style={{
                            fontSize: "14px",
                            color: "#13c2c2",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </div>
                  }
                  size="small"
                  style={{
                    borderLeft: "3px solid #13c2c2",
                    borderBottom: 0,
                    paddingBottom: 0,
                  }}
                >
                  <Form.Item
                    name="intro_script"
                    label={
                      <span style={{ fontWeight: 500 }}>Greeting Message</span>
                    }
                    extra="This appears when the widget initializes"
                  >
                    <Input.TextArea
                      rows={3}
                      maxLength={350}
                      showCount
                      placeholder="Hi there! How can I help you today?"
                      style={{ resize: "none" }}
                      size="large"
                    />
                  </Form.Item>
                </Card>
              </Tabs.TabPane>
            </Tabs>
          </div>

          {/* Custom Footer */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px 0",
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <div style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: 12 }}>
              Last updated: {new Date().toLocaleString()}
            </div>
            <Space>
              <Button
                type="default"
                icon={<VscDiscard />}
                size="large"
                onClick={handleCancelSettingsModal}
              >
                Discard Changes
              </Button>
              <Button
                type="primary"
                size="large"
                loading={settingsLoading}
                onClick={() => {
                  form
                    .validateFields()
                    .then(handleSettingsChange)
                    .catch((errorInfo) => {
                      // Show error message
                      message.error("Please fill all required fields");

                      // If contact fields are enabled, check specific requirements
                      if (enableNumberInput) {
                        const contactPoint = form.getFieldValue(
                          "contact_prompt_point"
                        );
                        const notificationEmail = form.getFieldValue(
                          "notification_emailid"
                        );

                        if (!contactPoint) {
                          message.warning(
                            "Contact form position number is required"
                          );
                        }
                        if (!notificationEmail) {
                          message.warning("Notification email is required");
                        }
                      }

                      if (enableSalesforceIntegration) {
                        const salesforceProjectValue =
                          form.getFieldValue("salesforce_project");
                        const salesforceUrlValue =
                          form.getFieldValue("salesforce_url");

                        if (!salesforceProjectValue) {
                          message.warning(
                            "Salesforce Project name is required"
                          );
                        }
                        if (!salesforceUrlValue) {
                          message.warning("Salesforce URL is required");
                        }
                      }

                      // Find the first tab with error and switch to it
                      const fieldsWithError = errorInfo.errorFields.map(
                        (field) => field.name[0]
                      );

                      if (
                        fieldsWithError.includes("contact_prompt_point") ||
                        fieldsWithError.includes("notification_emailid") ||
                        fieldsWithError.includes("contact_attributes") ||
                        fieldsWithError.includes("salesforce_project") ||
                        fieldsWithError.includes("salesforce_url")
                      ) {
                        // Switch to Core Settings tab
                        form.getFieldInstance("tabs")?.onChange("1");
                      }
                    });
                }}
                icon={<SaveOutlined />}
              >
                Save Configuration
              </Button>
            </Space>
          </div>
        </Form>
      </Modal>

      {/* Preview Modal */}
      <Modal
        title="Avatar Preview"
        open={isPreviewModalVisible}
        onCancel={() => setIsPreviewModalVisible(false)}
        centered
        footer={[
          <Button
            key="close"
            type="primary"
            onClick={() => setIsPreviewModalVisible(false)}
          >
            Close
          </Button>,
        ]}
      >
        <div style={{ maxWidth: "600px", margin: "auto" }}>
          {renderPreview()}
        </div>
      </Modal>

      {/* Code Modal */}
      <Modal
        title="Generated Code"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        width={800}
        style={{ top: 20 }}
        footer={[
          <Button
            key="copy"
            icon={<FaCopy />}
            type="primary"
            onClick={handleCopyCode}
            disabled={getCodeLoading}
          >
            Copy Code
          </Button>,
          <Button
            key="download"
            icon={<FaCloudDownloadAlt />}
            onClick={handleDownload}
            disabled={getCodeLoading}
          >
            Download
          </Button>,
        ]}
      >
        <p>This code is ready for integration into your application.</p>
        <div
          style={{
            backgroundColor: "#f8f8f8",
            padding: "30px",
            marginTop: "20px",
            overflow: "auto",
            borderRadius: "8px",
          }}
        >
          {getCodeError ? (
            <Text type="danger">{getCodeError}</Text>
          ) : getCodeLoading ? (
            <Spin size="large" />
          ) : (
            <pre ref={preRef}>{code}</pre>
          )}
        </div>
      </Modal>

      {/* Processing Indicator */}
      <ProcessingModal
        isProcessing={isProcessing}
        setIsProcessing={setIsProcessing}
        progress={avatarData?.progress}
      />
      <Card
        style={{
          marginTop: 30,
          border: "none",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              role="img"
              aria-label="integration"
              style={{ fontSize: "24px" }}
            >
              <LinkOutlined />
            </span>
            <span style={{ fontSize: "18px", fontWeight: 600 }}>
              Widget Integration Guide
            </span>
          </div>
        }
      >
        <div style={{ padding: "12px 24px" }}>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          >
            <div
              style={{
                padding: "20px",
                backgroundColor: "#f8f9ff",
                borderRadius: "12px",
                border: "1px solid #e6e8f0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "12px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#1677ff",
                    color: "white",
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  1
                </div>
                <Text strong style={{ fontSize: "16px" }}>
                  Get the Code
                </Text>
              </div>
              <Text>
                Click the <Tag color="blue">Get Code</Tag> button in the
                dashboard when it's enabled.
              </Text>
            </div>

            <div
              style={{
                padding: "20px",
                backgroundColor: "#fff8f0",
                borderRadius: "12px",
                border: "1px solid #ffe7ba",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "12px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fa8c16",
                    color: "white",
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  2
                </div>
                <Text strong style={{ fontSize: "16px" }}>
                  Add to Your Website
                </Text>
              </div>
              <Space direction="vertical" size="small">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <CheckCircleOutlined style={{ color: "#fa8c16" }} />
                  <Text>Copy the generated code snippet</Text>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <CheckCircleOutlined style={{ color: "#fa8c16" }} />
                  <Text>
                    Paste inside the{" "}
                    <Text code>
                      {`<body>`} / {`<head>`}
                    </Text>{" "}
                    tag
                  </Text>
                </div>
              </Space>
            </div>

            <div
              style={{
                padding: "20px",
                backgroundColor: "#f6ffed",
                borderRadius: "12px",
                border: "1px solid #b7eb8f",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "12px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#52c41a",
                    color: "white",
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  3
                </div>
                <Text strong style={{ fontSize: "16px" }}>
                  Verify Installation
                </Text>
              </div>
              <Text>
                Refresh your website and look for the chat widget in the
                bottom-right corner.
              </Text>
            </div>
          </div>

          <Alert
            style={{ marginTop: "24px" }}
            type="info"
            showIcon
            icon={<InfoCircleOutlined style={{ color: "#1677ff" }} />}
            message={
              <Text strong style={{ fontSize: "15px" }}>
                Important Notes
              </Text>
            }
            description={
              <div style={{ marginTop: "8px" }}>
                <Space direction="vertical" size="small">
                  <Text>
                    If you have any queries, contact{" "}
                    <Text style={{ color: "#1677ff" }}>
                      support@face-bot.ai
                    </Text>
                  </Text>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FloatButton.Group trigger="hover" style={{ right: 24 }}>
                      <FloatButton
                        icon={<CustomerServiceOutlined />}
                        tooltip="Need Help?"
                        onClick={() =>
                          message.info("Contact support@face-bot.ai")
                        }
                      />
                      <FloatButton
                        icon={
                          isActive ? (
                            <CheckCircleOutlined />
                          ) : (
                            <CloseCircleOutlined />
                          )
                        }
                        tooltip={`Status: ${isActive ? "Active" : "Inactive"}`}
                        style={{
                          backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
                          color: "#fff",
                        }}
                      />
                    </FloatButton.Group>
                  </div>
                </Space>
              </div>
            }
          />
        </div>
      </Card>
    </div>
  );
};

export default ContentPage;
